import { useState, useEffect } from 'react';

export default function ThemeSwitcher() {
    
    const [theme, setTheme] = useState(localStorage.getItem('theme') || 'light');
    
    const themeIcons = {
        light: "bi bi-sun-fill",
        dark: "bi bi-moon-stars-fill",
        auto: "bi bi-circle-half"
    };

    const toggleTheme = (newTheme) => {
        setTheme(newTheme);
        document.documentElement.setAttribute('data-bs-theme', newTheme); // Cambia el tema
        localStorage.setItem('theme', newTheme); // Guarda la preferencia en localStorage
    };

    useEffect(() => {
        document.documentElement.setAttribute('data-bs-theme', theme); // Establece el tema cuando el componente se monta
    }, [theme]);

    return (
        <>
            <div className="dropdown">
                <button className="btn nav-link py-2 px-0 px-lg-2 dropdown-toggle" id="bd-theme" type="button" aria-expanded="false" data-bs-toggle="dropdown" aria-label="Toggle theme">
                    <i className={themeIcons[theme]}></i>
                    <span className="d-lg-none ms-2" id="bd-theme-text">Toggle theme</span>
                </button>
                <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="bd-theme-text">
                    <li>
                        <button type="button" className="dropdown-item d-flex align-items-center" onClick={() => toggleTheme('light')} aria-pressed={theme === 'light'} >
                            <i className="bi bi-sun-fill me-2"></i>Light
                            {theme === 'light' && <i className="bi bi-check2 ms-auto"></i>}
                        </button>
                    </li>
                    <li>
                        <button type="button" className="dropdown-item d-flex align-items-center" onClick={() => toggleTheme('dark')} aria-pressed={theme === 'dark'} >
                            <i className="bi bi-moon-stars-fill me-2"></i>Dark
                            {theme === 'dark' && <i className="bi bi-check2 ms-auto"></i>}
                        </button>
                    </li>
                    <li>
                        <button type="button" className="dropdown-item d-flex align-items-center" onClick={() => toggleTheme('auto')} aria-pressed={theme === 'auto'} >
                            <i className="bi bi-circle-half me-2"></i>Auto
                            {theme === 'auto' && <i className="bi bi-check2 ms-auto"></i>}
                        </button>
                    </li>
                </ul>
            </div>
        </>
    );
}